<template>
  <div class="card h-100 border-primary">
    <router-link :to="'/viewer/' + poster.abstract_id" class="mx-auto h-100">
      <img class="mx-auto img-fluid"
           v-lazy="getImgUrl(poster.content.poster)"
           v-bind:alt="poster.title">
    </router-link>
    <router-link :to="'/viewer/' + poster.abstract_id" class="card-body text-bg-primary h-100">
      <h6 class="card-title small fw-bold h-100" v-html="poster.title"></h6>
    </router-link>
    <div class="card-footer text-bg-primary h-100">
      <div class="row mb-2">
        <div class="col-4 small">
          {{ poster.presentation_code }}
        </div>
        <div class="col text-end" v-if="setting.rating === true">
          {{ _.card_rating }} : {{ ratings[poster.id].rating }} ({{ ratings[poster.id].count }} votes)
        </div>
      </div>
      <div class="row">
        <div class="col d-flex justify-content-evenly">
          <router-link class="btn btn-link btn-sm text-bg-primary pointer-click flex-grow-1 flex-"
                       :to="'/viewer/' + poster.abstract_id">
            <icon :icon="['fal', 'eye']" class="fa-2x"/>
            <div class="my-auto">{{ _.card_view }}</div>
          </router-link>
          <router-link class="btn btn-link btn-sm text-bg-primary pointer-click flex-grow-1"
                       v-if="poster.content.audio"
                       :to="'/viewer/' + poster.abstract_id">
            <icon :icon="['fal', 'volume']" class="fa-2x"/>
            <div class="my-auto">{{ _.card_audio }}</div>
          </router-link>
          <router-link class="btn btn-link btn-sm text-bg-primary pointer-click flex-grow-1"
                       v-if="poster.content.video"
                       :to="'/viewer/video/' + poster.abstract_id">
            <icon :icon="['fal', 'film']" class="fa-2x"/>
            <div class="my-auto">{{ _.card_video }}</div>
          </router-link>
          <button class="btn btn-link btn-sm text-bg-primary pointer-click flex-grow-1" v-if="setting.contact === true"
                  v-on:click="openContact(poster.abstract_id)">
            <icon :icon="['fal', 'message']" class="fa-2x"/>
            <div class="my-auto">&nbsp;{{ _.card_contact }}</div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapMutations, mapState} from "vuex";
import {Modal} from 'bootstrap';

export default {
  name: 'Card',
  props: {
    poster: {}
  },
  computed: {
    ...mapState([
      'posters', 'mode', 'fullscreen', 'loader', 'themes', 'datahelper', 'ratings', 'setting'
    ]),
    ...mapState('theme', ['firstLevelTheme', 'secondLevelTheme', 'selectedTheme']),
    ...mapGetters([
      'filteredPosters',
    ]),
    selectedThemeComp: {
      get() {
        return this.selectedTheme
      },
      set(id) {
        this.setSelectedTheme(id);
      }
    }
  },
  methods: {
    ...mapMutations(['setContactPoster']),
    getImgUrl(src) {
      //return process.env.VUE_APP_PATH_FILESERVERURL + src + '/resize/' + process.env.VUE_APP_THUMBNAIL_WIDTH + '/' + process.env.VUE_APP_THUMBNAIL_HEIGHT;
       return process.env.VUE_APP_PATH_S3URL + src + '-' + process.env.VUE_APP_THUMBNAIL_WIDTH + '-' + process.env.VUE_APP_THUMBNAIL_HEIGHT;
    },
    openContact(poster_id) {
      this.setContactPoster(poster_id);
      let modal = new Modal(document.getElementById('modalContact'));
      modal.show();
    }
  }
}
</script>
